<template>
  <div class="pn-skeleton-container">
    <div class="pn-skeleton-container-header">
      <Skeleton height="20px" width="150px" borderRadius="4px" />
    </div>
    <div class="pn-skeleton-container-main">
      <div class="pn-skeleton-container-main-top">
        <Skeleton height="18px" width="170px" borderRadius="4px" />
        <Skeleton height="14px" width="600px" borderRadius="4px" />
      </div>
      <div class="pn-skeleton-container-main-middle">
        <div class="pn-skeleton-container-main-middle-left">
          <Skeleton height="80px" fullWidth borderRadius="4px" />
          <Skeleton height="80px" fullWidth borderRadius="4px" />
          <Skeleton height="40px" fullWidth borderRadius="4px" />
        </div>
        <div class="pn-skeleton-container-main-middle-right">
          <Skeleton height="80px" fullWidth borderRadius="4px" />
          <Skeleton height="80px" fullWidth borderRadius="4px" />
          <Skeleton height="40px" fullWidth borderRadius="4px" />
        </div>
      </div>
    </div>
    <div class="pn-skeleton-container-values">
      <div class="pn-skeleton-container-values-top">
        <Skeleton height="18px" width="170px" borderRadius="4px" />
        <Skeleton height="14px" width="600px" borderRadius="4px" />
      </div>
      <div class="pn-skeleton-container-values-bottom">
        <div class="pn-skeleton-container-values-bottom-left">
          <Skeleton height="40px" fullWidth borderRadius="4px" />
        </div>
        <div class="pn-skeleton-container-values-bottom-right">
          <div class="pn-skeleton-container-values-bottom-right-first">
            <Skeleton height="40px" width="32%" borderRadius="4px" />
            <Skeleton height="40px" width="32%" borderRadius="4px" />
            <Skeleton height="40px" width="32%" borderRadius="4px" />
          </div>
          <div class="pn-skeleton-container-values-bottom-right-second">
            <Skeleton height="40px" width="32%" borderRadius="4px" />
            <Skeleton height="40px" width="32%" borderRadius="4px" />
            <Skeleton height="40px" width="32%" borderRadius="4px" />
          </div>
          <div class="pn-skeleton-container-values-bottom-right-third">
            <Skeleton height="40px" width="32%" borderRadius="4px" />
            <Skeleton height="40px" width="32%" borderRadius="4px" />
          </div>
        </div>
      </div>
    </div>
    <div class="pn-skeleton-container-footer">
      <div class="pn-skeleton-container-footer-left">
        <Skeleton width="20px" height="20px" borderRadius="4px" />
        <Skeleton width="206px" height="16px" borderRadius="4px" />
      </div>
      <div class="pn-skeleton-container-footer-right">
        <Skeleton width="212px" height="40px" borderRadius="6px" />
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.pn-skeleton-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid $colorD20;
  background: $colorN00;

  &-header,
  &-main,
  &-values,
  &-footer {
    align-self: stretch;
  }

  &-main,
  &-main-top,
  &-main-middle-left,
  &-main-middle-right,
  &-values,
  &-values-top,
  &-values-bottom-left,
  &-values-bottom-right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &-header,
  &-footer {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &-header {
    padding: 24px 24px 16px 24px;
    border-bottom: 0.5px solid $colorD20;
  }

  &-main {
    padding: 16px 24px 24px 24px;
    gap: 16px;
    border-bottom: 0.5px solid $colorD30;

    &-top {
      gap: 12px;
      align-self: stretch;
    }

    &-middle {
      display: flex;
      align-items: center;
      gap: 24px;
      align-self: stretch;

      &-left,
      &-right {
        gap: 16px;
        flex: 1 0 0;
      }
    }
  }

  &-values {
    padding: 24px 24px 16px 24px;
    gap: 16px;

    &-top {
      gap: 12px;
      align-self: stretch;
    }

    &-bottom {
      display: flex;
      align-items: flex-start;
      align-content: flex-start;
      gap: 12px;
      align-self: stretch;
      flex-wrap: wrap;

      &-left,
      &-right {
        flex: 1 0 0;
        gap: 16px;
      }

      &-right-first,
      &-right-second,
      &-right-third {
        display: flex;
        align-items: center;
        gap: 10px;
        align-self: stretch;
      }
    }
  }

  &-footer {
    padding: 0 24px 24px 24px;
    justify-content: flex-end;

    &-left {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &-right {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 2px;
    }
  }
}
</style>
